import React, { useContext, useEffect } from 'react'
import MobileConfirmSlotForm from './Mobile/MobileConfirmSlotForm'
import ComputerConfirmSlotForm from './Computer/ComputerConfirmSlotForm'
import TabletConfirmSlotForm from './Tablet/TabletConfirmSlotForm'
import { screenSize } from '../../Common/Common'
import PublicContext from '../PublicContext'
import { useNavigate } from 'react-router'
import { post } from '../../Common/api'
import { t } from 'i18next'
import { notification } from 'antd'

export default function ConfirmSlotForm () {
  const { data, slot, setLoading, setSiderTitle } = useContext(PublicContext)
  const navigate = useNavigate()

  const onFinish = (values) => {
    setLoading(true)
    post({
      url: `public/slots/${slot.id}/confirm`,
      params: values,
      onSuccess: () => {
        setLoading(false)
        navigate(`/slots/${slot.id}`)
      },
      onFailure: (response) => {
        let message = t('Public.ConfirmSlotForm.error')
        if (Object.keys(response.errors).length !== 0) {
          message = Object.keys(response.errors).map(key => (response.errors[key]))
        }
        notification.error({ message, placement: 'bottom' })
        setLoading(false)
      }
    })
  }

  const onFinishFailed = () => {
    setLoading(false)
  }

  const resendCode = () => {
    post({
      url: `public/slots/${slot.id}/resend_confirmation_code`,
      params: {},
      onSuccess: () => {
        notification.success({ message: t('Public.ConfirmSlotForm.resendSuccess'), placement: 'bottom' })
      }
    })
  }

  const initialValues = {
    start_timestamp: data?.slotTime?.start,
    end_timestamp: data?.slotTime?.end,
    calendar_id: data?.calendarId,
    country: data?.country,
    civility: data?.civility,
    reason_id: data?.reasonId
  }

  useEffect(() => {
    setSiderTitle(t('Public.ConfirmSlotPage.title'))
  }, [])

  const slotForm = {
    Mobile: MobileConfirmSlotForm,
    Computer: ComputerConfirmSlotForm,
    Tablet: TabletConfirmSlotForm
  }

  const ResponsiveForm = slotForm[screenSize()]

  return (
    <ResponsiveForm initialValues={initialValues} resendCode={resendCode} onFinishFailed={onFinishFailed} onFinish={onFinish} />
  )
}
